export default __webpack_public_path__ + "static/media/probation-16px.08d21df1.svg";